import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";

import {createLogoutRequest} from "../../actions/logoutAction";
import { changeTab } from "../../actions/userAction"
import { encrypt , decrypt } from "../../helpers/CryptoJs";
import { getlanguagelist } from "../../helpers/changelanguage";
import './Sidebar.css';

class Sidebar extends Component {
    constructor(props) {
      super(props);
      this.state = {
        userId : this.props.currentUserDetails.user.id
  
      };
      this.logout      = this.logout.bind(this);
      this.gotoProfile = this.gotoProfile.bind(this);
      this.hover       = this.hover.bind(this);
      this.unhover     = this.unhover.bind(this);
      this.openApp     = this.openApp.bind(this);
    
    }
    componentDidMount(){
        
    }

    logout() {
        this.props.createLogoutRequest(this.state);
    }  
    gotoProfile(currentTab){
        let redirectto = this.state.userId;
        if((this.props.currentUserDetails.user.id != this.state.userId) && (this.props.currentUserDetails.user.id != undefined)){
            redirectto = this.props.currentUserDetails.user.id;
        } 
        this.props.changeTab(currentTab);
        this.props.history.push(`/user/${encrypt(redirectto)}/${currentTab}`)
    }
    
    UNSAFE_componentWillReceiveProps(nextProps){ 
        
    }

    hover(type) {
        if(type == 'promotion'){
            document.getElementById("promotion").setAttribute('src', "/assets/images/promotion_icon_selected.png");
        }else if(type == 'goldenspace'){
            document.getElementById("goldenspace").setAttribute('src', "/assets/images/left_panel_golden_space_hover.png");
        }else if(type == 'profiles'){
            document.getElementById("profiles").setAttribute('src', "/assets/images/leftmenu_icon2_selected.png");
        }else if(type == 'gallery'){
            document.getElementById("gallery").setAttribute('src', "/assets/images/leftmenu_icon3_selected.png");
        }else if(type == 'event'){
            document.getElementById("event").setAttribute('src', "/assets/images/leftmenu_icon4_selected.png");
        }else if(type == 'friend'){
            document.getElementById("friend").setAttribute('src', "/assets/images/leftmenu_icon5_selected.png");
        }else if(type == 'page'){
            document.getElementById("page").setAttribute('src', "/assets/images/leftmenu_icon6_selected.png");
        }else if(type == 'term'){
            document.getElementById("term").setAttribute('src', "/assets/images/leftmenu_icon7_selected.png");
        }else if(type == 'privacy'){
            document.getElementById("privacy").setAttribute('src', "/assets/images/leftmenu_icon8_selected.png");
        }else if(type == 'aboutus'){
            document.getElementById("aboutus").setAttribute('src', "/assets/images/leftmenu_icon8_selected.png");
        }else if(type == 'faq'){
            document.getElementById("faq").setAttribute('src', "/assets/images/leftmenu_icon9_selected.png");
        }else if(type == 'logout'){
            document.getElementById("logout").setAttribute('src', "/assets/images/leftmenu_icon11_selected.png");
        }
    }
      
    unhover(type) {
        if(type == 'promotion'){
            document.getElementById("promotion").setAttribute('src', "/assets/images/promotion_icon.png");
        }else if(type == 'goldenspace'){
            document.getElementById("goldenspace").setAttribute('src', "/assets/images/left_panel_golden_space.png");
        }else if(type == 'profiles'){
            document.getElementById("profiles").setAttribute('src', "/assets/images/leftmenu_icon2.png");
        }else if(type == 'gallery'){
            document.getElementById("gallery").setAttribute('src', "/assets/images/leftmenu_icon3.png");
        }else if(type == 'event'){
            document.getElementById("event").setAttribute('src', "/assets/images/leftmenu_icon4.png");
        }else if(type == 'friend'){
            document.getElementById("friend").setAttribute('src', "/assets/images/leftmenu_icon5.png");
        }else if(type == 'page'){
            document.getElementById("page").setAttribute('src', "/assets/images/leftmenu_icon6.png");
        }else if(type == 'term'){
            document.getElementById("term").setAttribute('src', "/assets/images/leftmenu_icon7.png");
        }else if(type == 'privacy'){
            document.getElementById("privacy").setAttribute('src', "/assets/images/leftmenu_icon8.png");
        }else if(type == 'aboutus'){
            document.getElementById("aboutus").setAttribute('src', "/assets/images/leftmenu_icon8.png");
        }else if(type == 'faq'){
            document.getElementById("faq").setAttribute('src', "/assets/images/leftmenu_icon9.png");
        }else if(type == 'logout'){
            document.getElementById("logout").setAttribute('src', "/assets/images/leftmenu_icon11.png");
        }
    }
    openApp(){
        $("#appModal").modal('show');
    }

    render() {
        let  languagelist = getlanguagelist();
        return (<div className="left_quick_block">
       <Link to="/promotion_list" className="quick_link" >
           <img src="/assets/images/promotion_icon_selected.png" />
           <div className="tooltiptext">{ languagelist.menu_promotion }</div>
       </Link>
       <a className="quick_link checkApp">
           <img src="/assets/images/left_panel_golden_space_hover.png" />
           <div className="tooltiptext">{ languagelist.goldenspace }</div>
       </a>
       <a onClick={()=>this.gotoProfile(3)} className="quick_link" >
            <img src="/assets/images/leftmenu_icon2_selected.png" />
           <div className="tooltiptext">{ languagelist.menu_profile }</div>
       </a>
       <a  onClick={()=>this.gotoProfile(2)} className="quick_link" >
            <img src="/assets/images/leftmenu_icon3_selected.png" id="gallery"/> 
            <div className="tooltiptext">{ languagelist.menu_gallery }</div>
       </a>
       <a className="quick_link checkApp" >
           <img src="/assets/images/leftmenu_icon4_selected.png" />
           <div className="tooltiptext">{ languagelist.menu_events }</div>
       </a>
       <a onClick={()=>this.gotoProfile(1)} className="quick_link" >
            <img src="/assets/images/leftmenu_icon5_selected.png" /> 
            <div className="tooltiptext">{ languagelist.menu_friends }</div>
       </a>
       <a className="quick_link checkApp" >
           <img src="/assets/images/leftmenu_icon6_selected.png" id="page"/>
           <div className="tooltiptext">{ languagelist.menu_page }</div>
       </a>
       <a href="https://www.baaldahab.com/terms_n_condition" target="_blank" className="quick_link"  >
           <img src="/assets/images/leftmenu_icon7_selected.png" id="term"/>
           <div className="tooltiptext">{ languagelist.menu_terms }</div>
       </a>
       <a href="https://www.baaldahab.com/privacy_policy" target="_blank" className="quick_link" >
           <img src="/assets/images/leftmenu_icon8_selected.png" id="privacy"/>
           <div className="tooltiptext">{ languagelist.menu_privacy }</div>
       </a>
       <a href="https://www.baaldahab.com/about_us" target="_blank" className="quick_link" >
           <img src="/assets/images/leftmenu_icon4_selected.png" id="about"/>
           <div className="tooltiptext">{ languagelist.menu_aboutus }</div>
       </a>
       <a href="https://www.baaldahab.com/faq" className="quick_link" >
           <img src="/assets/images/leftmenu_icon9_selected.png" id="faq" />
           <div className="tooltiptext">{ languagelist.menu_faq }</div>
       </a>
       <a className="quick_link" onClick={this.logout} >
           <img src="/assets/images/leftmenu_icon11_selected.png" id="logout"/>
           <div className="tooltiptext">{ languagelist.logout }</div>
       </a>
     </div>
    );
    }
}

const mapStateToProps = state => {

    return {
            loggedOutUser      : state.logout.loggedUser,
            currentUserDetails : state.login,
            userFriendDetails  : state.frienddetail['friendDetail'],
           }
  }
  const mapDispatchToProps = dispatch => {
    return {
      createLogoutRequest  : bindActionCreators(createLogoutRequest, dispatch),
      changeTab            : bindActionCreators(changeTab, dispatch),
      
    }
  }
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));
